<template>
    <section class="o-wrapper o-wrapper--center o-page-bottom-spacing">
        <template>
            <page-header>
                <slot slot="title">{{$t('footer.our_brands')}}</slot>
                <slot slot="description">
                    {{ $t('intro.customer_our_brands') }}
                </slot>
            </page-header>

            <div class="o-wrapper o-wrapper--center">

                <div v-model="selectedLetter" class="alphabet__search">
                    <span @click="setActiveLetter(undefined)" :class="{ 'active': selectedLetter === undefined }">ALL</span>
                    <span @click="setActiveLetter(letter)"
                          v-for="letter in alphabet"
                          :class="{ 'active': selectedLetter === letter }">
                        {{ letter }}
                    </span>
                </div>

                <router-link :to="{ name: 'ShopOverview', query: {'Brands': brand.Name, 'addBranchFilter': false}  }"
                             v-for="brand in filteredBrands" :key="brand.Id"
                             v-if="brand.Name !== ''"
                             class="c-our-brand">
                    {{ brand.Name }}
                </router-link>

                <div v-if="filteredBrands.length === 0" class="u-text-align-center u-font-italic">
                    Uw selectie bevat geen merken. Kies een andere letter of klik op <strong>ALL</strong>
                </div>

            </div>


        </template>
    </section>
</template>

<script>
    import Vue from 'vue'
    import PageHeader from '@/components/common/PageHeader'
    import VInput from '@/components/form/Input'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            PageHeader,
            VInput
        },
        data(){
            return {
                alphabet: [],
                selectedLetter: undefined,
            }
        },
        created (){
            this.initialDataFetch()
            this.alphabet = this.GenerateAlphabet('a','z')
        },
        computed:{
            ...mapGetters({
                BrandsOptions: 'BrandsOptions'
            }),
            filteredBrands () {
                let brands = this.BrandsOptions
                if (this.selectedLetter) {
                    brands = brands.filter((brand) => {
                        let firstLetter = brand.Name.charAt(0).toLowerCase()
                        return firstLetter === this.selectedLetter
                    })
                }
                return brands
            }
        },
        methods:{
            initialDataFetch(){
                this.$store.dispatch("getBrandsOptions");
            },
            GenerateAlphabet(charA, charZ) {
                let a = [], i = charA.charCodeAt(0), j = charZ.charCodeAt(0);
                for (; i <= j; ++i) {
                    a.push(String.fromCharCode(i));
                }
                return a;
            },
            setActiveLetter(value) {
                this.selectedLetter = value;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .c-our-brand {
        display: inline-block;
        color: $color-base;
        width: 24%;
        padding: 4em 0.25em;
        margin-right: 1%;
        margin-bottom: 1%;
        font-size: em(16px);
        text-decoration: none;
        text-align: center;
        border: 2px solid $color-neutral;
        transition: all 0.3s;

        &:hover {
            background-color: $color-alpha;
            color: $color-white;
            border-color: $color-alpha;
        }
    }

    .alphabet__search {
        text-align: center;
        margin-bottom: 2em;
        span {
            display: inline-block;
            text-transform: uppercase;
            padding: 0.25em 0.25em;
            width: 30px;
            text-align: center;
            cursor: pointer;
            margin-right: 3px;

            &:first-child {
                width: 75px;
            }

            &:hover {
                background-color: $color-neutral;
            }

            &.active {
                font-weight: bold;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/customer/ourBrands/Overview.vue